import styled from "styled-components";
import Colors from "../../global/color";

const StyledButton = styled.button`
  && {
    height: 50px;
    background-color: #333333;
    width: 335px;
    border: 1px solid transparent;
    font-family: FuturaPT-Book;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 3px;
    line-height: 24px;
    position: fixed;
    bottom: 20px;
    border-radius: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    span {
      color: #fff;
      -webkit-transition: color 0.3s ease-out;
      -moz-transition: color 0.3s ease-out;
      -ms-transition: color 0.3s ease-out;
      -o-transition: color 0.3s ease-out;
      transition: color 0.3s ease-out;
    }
    -webkit-transition: border-color 0.3s ease-out, background 0.3s ease-out;
    -moz-transition: border-color 0.3s ease-out, background 0.3s ease-out;
    -ms-transition: border-color 0.3s ease-out, background 0.3s ease-out;
    -o-transition: border-color 0.3s ease-out, background 0.3s ease-out;
    transition: border-color 0.3s ease-out, background 0.3s ease-out;
    @media (hover: hover) {
      &:hover {
        background-color: #fff;
        border: 1px solid ${Colors.goldLight};
        cursor: pointer;
        span {
          color: ${Colors.goldLight} !important;
        }
      }
    }
    z-index: 10;
    ${(props) => props.customstyles};
    &:disabled {
      background-color: #000;
      color: #797979;
      opacity: 1;
      border-color: #999;
      cursor: no-drop;
    }
    &:active {
      background: #000;
      border-color: white;
    }
    &:focus {
      box-shadow: none;
      outline: none;
    }
  }
`;

export { StyledButton };
